import { ArrowUpRight } from "lucide-react";
import StarField from "./StarField";
import { CONTACT_URL } from "../content";
import { track } from "../lib/analytics";

export default function CTA({ t }) {
  const handleContactClick = () => {
    track("contact_click");
    track("book_demo");
  };

  return (
    <section
      data-testid="cta-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 100%, rgba(255,184,0,0.12), transparent 60%)",
        }}
        aria-hidden="true"
      />
      <StarField count={40} />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="font-mono text-[11px] tracking-[0.3em] text-[var(--primary)] mb-6 inline-flex items-center gap-3">
          <span className="h-px w-10 bg-[var(--primary)]" />
          {t.cta.kicker}
          <span className="h-px w-10 bg-[var(--primary)]" />
        </div>
        <h2
          data-testid="cta-title"
          className="font-display font-black uppercase leading-[1] text-3xl md:text-5xl lg:text-6xl"
        >
          <span className="block text-white">{t.cta.title}</span>
          <span className="block text-[var(--primary)]">
            {t.cta.titleAccent}
          </span>
        </h2>
        <p
          data-testid="cta-body"
          className="mt-8 max-w-2xl mx-auto text-white/65 text-base md:text-lg"
        >
          {t.cta.body}
        </p>
        <a
          href={CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-primary-button"
          onClick={handleContactClick}
          className="group inline-flex items-center gap-3 mt-10 bg-[var(--primary)] text-black font-mono text-xs tracking-[0.25em] uppercase font-semibold px-8 py-4 hover:bg-[var(--primary-hover)] transition-colors"
        >
          {t.cta.ctaPrimary}
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </section>
  );
}
